"use client";

import React from "react";
import "./css/Button.css";
import TableItem from "./TableItem";

const TwoColumnTable = ({ items, withinContainer }) => {
  const element = (
    <>
      <div className="tps-editable-text cell margin-bottom-3">
        <div className="table-scroll">
          <table
            border="1"
            cellPadding="1"
            cellSpacing="1"
            role="presentation"
            style={{ width: "100%" }}
          >
            <tbody>
              {items &&
                items.map((item, index) => {
                  return (
                    <TableItem
                      image={item?.image?.data?.attributes}
                      key={index}
                      text={item?.text}
                    />
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );

  return withinContainer ? (
    <div className={"grid-container"}>{element}</div>
  ) : (
    element
  );
};

export default TwoColumnTable;
